module.exports = __webpack_public_path__ + "client-static/img/logo_mandiri_atm.f1527f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_mandiri_atm.png
// module id = NYcI
// module chunks = 2